import React from "react";
import styles from "./styles.module.scss";
import nullTagsIcon from "../../../../public/images/null-tags.png";
import { useTranslation } from "react-i18next";
import { cls } from "app/utils";

const NoTags: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {/* Decorative: the heading and description below convey the state. */}
      <img src={nullTagsIcon} alt="" />
      <div className={styles.text}>
        <h3 className={cls(styles.title, "bold")}>{t("No tags")}</h3>
        <p className={styles.description}>
          {t("Tags you create will appear here")}
        </p>
      </div>
    </div>
  );
};

export default NoTags;
